/**
 * Created by Alican Köker on 2019-04-01.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EdisonGameConfig} from "../../EdisonGameConfig";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { TimelineLite } from "gsap";
import {EdisonGameMode} from "../../gameMode/EdisonGameMode";
import { EdisonGameModuleConfig } from "../../EdisonGameModuleConfig";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { EdisonParsedGameData } from "../../server/data/EdisonParsedGameData";
import { EdisonHelper } from "../../../utils/EdisonHelper";

export class EdisonIndividualWPView extends BaseView {

    private _layer:ScalableLayer;
    private _frameSpineContainerSprite:PIXI.Sprite;
    private _gameMode:EdisonGameMode = EdisonGameMode.NORMAL;
    private _gameData:EdisonParsedGameData;

    public static readonly SET_MODE:string = "EdisonIndividualWPView_setMode";

    constructor() {
        super();

        this._layer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
        this._frameSpineContainerSprite = new PIXI.Sprite();
        this._layer.addChild(this._frameSpineContainerSprite);
        EventHandler.addEventListener(this, EdisonIndividualWPView.SET_MODE, (event:GameEvent) => this._gameMode = event.params[0]);
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private onGameDataParsed(data:EdisonParsedGameData):void {
        this._gameData = data;
    }

    protected onResize?(resizeData:IResizeData):void {

    }

    public playSPAnim(reelIndex:number, symbolIndex:number):TimelineLite {
        let stacked:boolean = EdisonHelper.checkStacked(this._gameData, reelIndex);
        return EdisonGameModuleConfig.winPresentationView.playFrameOverlay(reelIndex, stacked ? 1 : symbolIndex, false, stacked);
    }

    public hidePresentations():void {
        EdisonGameModuleConfig.winPresentationView.reset();
    }
}